import View from '../../../Core/View.js';

import { getPointsList, getLegendCategories } from './JsonHandler.js'

import Map from './Map.js'
import InfoBox from './InfoBox.js'
import Legend from './Legend.js'

class LocationMap extends View {

	initialize() {
		this.availableLegendPoints = [];
		this.positions = [];
		this._loadJsonFile();
	}

	_loadJsonFile() {
		const mapJsonElement = this.el.querySelector('.location-map__data')
		const json = window.atob(mapJsonElement.innerHTML);
		//this._removeScriptElementFromDOM(mapJsonElement);
		const jsonObject = JSON.parse(json);
		this._createMap(jsonObject)
	}

	_onMarkerClicked(point, marker) {
		this.infoBox.update(point, marker);
	}

	_removeScriptElementFromDOM(element) {
		this.el.removeChild(element);
	}

	_createMap(json) {
		this.availableLegendPoints = getLegendCategories(json);
		this.positions = getPointsList(json);
		this.map = new Map({
			el: this.el.querySelector('.location-map__container'),
			routeData: this.el.getAttribute('data-route'),
			centerPoint: this.el.getAttribute('data-center'),
			zoomLevel: this.el.getAttribute('data-zoom'),
			legendPoints: this.availableLegendPoints,
			allPositions: this.positions,
			onMarkerClick: this._onMarkerClicked.bind(this)
		});
		this.infoBox = new InfoBox({
			map: this.map.getGoogleMap(),
			el: this.el,
		});
		this.legend = new Legend({
			el: this.el.querySelector('.location-map__legend-container'),
			routeData: this._getValidRouteLegendObject(),
			categoryList: this.availableLegendPoints,
			routeColor: this.map.getRouteColor
		})
	}

	_getValidRouteLegendObject() {
		const routeNameGiven = this.el.getAttribute('data-route');

		let routeColor = '';

		if (routeNameGiven === null) {
			return null
		}
		for (let position in this.positions) {
			if (this.positions[position]['headTitle'] === routeNameGiven) {
				routeColor = this.positions[position]['color']
			}
		}
		return {
			name: routeNameGiven,
			color: routeColor,
			routesNames: this._getAllRouteNames()
		}

	}

	_getAllRouteNames() {
		let allRouteNames = [];
		for (let position in this.positions) {
			if (typeof this.positions[position]['coordinates'].length !== 'undefined') {
				allRouteNames.push(this.positions[position]['headTitle'])
			}
		}
		return allRouteNames;
	}

}

export default LocationMap;


// WEBPACK FOOTER //
// ./js/Views/Modules/LocationMap/LocationMap.js